import React, { createContext, useContext, useState, useEffect } from 'react';
import {BASE_URL,CDN_URL} from '../config/apiconfig';
const PromotionalModalContext = createContext();

export const usePromotionalModal = () => {
  const context = useContext(PromotionalModalContext);
  if (!context) {
    throw new Error('usePromotionalModal must be used within a PromotionalModalProvider');
  }
  return context;
};

export const PromotionalModalProvider = ({ children }) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBanners = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${BASE_URL}/banners`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === 200 && data.data) {
        // Filter only active banners and add full image URL
        const activeBanners = data.data
          .filter(banner => banner.status === 'active')
          .map(banner => ({
            ...banner,
            imageUrl: `${CDN_URL}/${banner.banner}`
          }));

        setBanners(activeBanners);
      } else {
        throw new Error('Invalid response format');
      }
    } catch (err) {
      setError(err.message);
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const value = {
    banners,
    loading,
    error,
    refetchBanners: fetchBanners
  };

  return (
    <PromotionalModalContext.Provider value={value}>
      {children}
    </PromotionalModalContext.Provider>
  );
};

export default PromotionalModalContext;
